export const NO_ASSIGNEE_ID = 0;
export const NOOP = () => {};
